// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1PWWe","right":"Footer_right__3H5go","buttons":"Footer_buttons__1VDYG"};